import React, { useEffect, useState } from "react";
import Icon from "components/AppIcon";
import { useLanguage } from "../../../LanguageContext";
import DeleteAreaModal from "./DeleteAreaModal";
import EditAreaModal from "./EditAreaModal";
import ShippingSettingsModal from "./ShippingSettingsModal";
import { useDispatch } from "react-redux";
import {
  deleteAreaService,
  getAllgovernoratesService,
} from "redux/services/general_service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const GovernrateTable = ({
  clients,
  selectedClients,
  onSelectClient,
  onDeleteClient,
  onEditClient,
  onAddArea,
}) => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const dispatch = useDispatch();

  const [deleteModal, setDeleteModal] = useState({ isOpen: false, area: null });
  const [editModal, setEditModal] = useState({ isOpen: false, area: null });
  const [shippingModal, setShippingModal] = useState({
    isOpen: false,
    area: null,
  });

  const translations = {
    id: language === "ar" ? "الرقم" : "ID",
    name: language === "ar" ? "الاسم" : "Name",
    areas: language === "ar" ? "المناطق المرتبطة" : "Areas",
    actions: language === "ar" ? "الإجراءات" : "Actions",
    addArea: language === "ar" ? "إضافة منطقة" : "Add Area",
    editArea: language === "ar" ? "تعديل المنطقة" : "Edit Area",
    deleteArea: language === "ar" ? "حذف المنطقة" : "Delete Area",
  };

  const handleDeleteAreaClick = (area) => {
    setDeleteModal({ isOpen: true, area });
  };

  const handleEditAreaClick = (area) => {
    setEditModal({ isOpen: true, area });
  };

  const handleConfirmDelete = (areaId) => {
    dispatch(deleteAreaService(areaId)).then((response) => {
      if (response.payload?.status === 200) {
        toast("تم الحذف بنجاح");
        setDeleteModal({ isOpen: false, area: null });
        dispatch(getAllgovernoratesService());
      }
    });
  };

  return (
    <div className="overflow-hidden">
      {/* ================= Desktop ================= */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500">
                {translations.id}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500">
                {translations.name}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500">
                {translations.areas}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500">
                {translations.actions}
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {clients?.map((client) => (
              <tr key={client.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-center text-sm">{client.id}</td>

                <td className="px-6 py-4 text-center text-sm font-medium">
                  {client?.translations?.ar?.name}
                </td>

                <td className="px-6 py-4 text-sm space-y-1">
                  {client?.provinces?.map((area) => (
                    <div
                      key={area.id}
                      className="flex items-center justify-between bg-gray-100 p-2 rounded"
                    >
                      <span>{area?.translations?.ar?.name}</span>

                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleEditAreaClick(area)}
                          className="text-blue-600 hover:text-blue-900"
                        >
                          <Icon name="Edit" size={14} />
                        </button>

                        <button
                          onClick={() => handleDeleteAreaClick(area)}
                          className="text-red-600 hover:text-red-900"
                        >
                          <Icon name="Trash2" size={14} />
                        </button>

                        <button
                          onClick={() =>
                            setShippingModal({ isOpen: true, area })
                          }
                          className="text-purple-600 hover:text-purple-900"
                        >
                          <Icon name="Truck" size={14} />
                        </button>
                      </div>
                    </div>
                  ))}
                </td>

                <td className="px-6 py-4 text-center">
                  <div className="flex justify-center space-x-2">
                    <button
                      onClick={() => onEditClient(client)}
                      className="text-green-600 hover:text-green-900"
                    >
                      <Icon name="Edit" size={16} />
                    </button>

                    <button
                      onClick={() => onDeleteClient(client.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>

                    <button
                      onClick={() => onAddArea(client)}
                      className="text-purple-600 hover:text-purple-900"
                    >
                      <Icon name="Plus" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= Mobile ================= */}
      <div className="lg:hidden divide-y divide-gray-200">
        {clients?.map((client) => (
          <div key={client.id} className="p-4">
            <div className="flex items-start space-x-3">
              <div className="flex-1">
                <div className="flex justify-between items-center">
                  <h3 className="text-sm font-semibold">
                    {client?.translations?.ar?.name}
                  </h3>
                  <span className="text-xs text-gray-500">ID: {client.id}</span>
                </div>

                <div className="mt-3 space-y-2">
                  {client?.provinces?.map((area) => (
                    <div
                      key={area.id}
                      className="flex items-center justify-between bg-gray-100 p-2 rounded text-xs"
                    >
                      <span>{area?.translations?.ar?.name}</span>

                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleEditAreaClick(area)}
                          className="text-blue-600 hover:text-blue-900"
                        >
                          <Icon name="Edit" size={12} />
                        </button>

                        <button
                          onClick={() => handleDeleteAreaClick(area)}
                          className="text-red-600 hover:text-red-900"
                        >
                          <Icon name="Trash2" size={12} />
                        </button>

                        <button
                          onClick={() =>
                            setShippingModal({ isOpen: true, area })
                          }
                          className="text-purple-600 hover:text-purple-900"
                        >
                          <Icon name="Truck" size={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-4 flex space-x-4">
                  <button
                    onClick={() => onEditClient(client)}
                    className="text-green-600 text-sm font-medium"
                  >
                    {t("edit")}
                  </button>

                  <button
                    onClick={() => onDeleteClient(client.id)}
                    className="text-red-600 text-sm font-medium"
                  >
                    {t("delete")}
                  </button>

                  <button
                    onClick={() => onAddArea(client)}
                    className="text-purple-600 text-sm font-medium"
                  >
                    {translations.addArea}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ================= Modals ================= */}
      <DeleteAreaModal
        isOpen={deleteModal.isOpen}
        onClose={() => setDeleteModal({ isOpen: false, area: null })}
        onConfirm={handleConfirmDelete}
        area={deleteModal.area}
        language={language}
      />

      <EditAreaModal
        isOpen={editModal.isOpen}
        onClose={() => setEditModal({ isOpen: false, area: null })}
        area={editModal.area}
        language={language}
      />

      <ShippingSettingsModal
        isOpen={shippingModal.isOpen}
        onClose={() => setShippingModal({ isOpen: false, area: null })}
        area={shippingModal.area}
      />
    </div>
  );
};

export default GovernrateTable;
